import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthComplete } from '../../contexts/AuthContext';
import { APP_NAME, ROUTES } from '../../utils/constants';

function Header() {
  const { user, isAuthenticated, logout } = useAuthComplete();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      setMobileMenuOpen(false);
      navigate(ROUTES.HOME);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="app-header" role="banner">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to={ROUTES.HOME} className="logo-link" onClick={closeMobileMenu} aria-label="QDN - Queer Data Network Home">
              <span className="logo-text">{APP_NAME}</span>
              <span className="logo-subtitle">Queer Data Network</span>
            </Link>
          </div>

          <button 
            className="hamburger-btn" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
            aria-controls="main-navigation"
          >
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>

          <nav id="main-navigation" className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`} role="navigation" aria-label="Main navigation">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to={ROUTES.HOME} className="nav-link" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to={ROUTES.CONTENT} className="nav-link" onClick={closeMobileMenu}>
                  Resources
                </Link>
              </li>
              <li className="nav-item">
                <Link to={ROUTES.COMMUNITY} className="nav-link" onClick={closeMobileMenu}>
                  Community
                </Link>
              </li>
              <li className="nav-item">
                <Link to={ROUTES.ABOUT} className="nav-link" onClick={closeMobileMenu}>
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to={ROUTES.SUPPORT} className="nav-link" onClick={closeMobileMenu}>
                  Support QDN
                </Link>
              </li>
              
              {/* Mobile-only user menu items */}
              {isAuthenticated && user && (
                <>
                  <li className="nav-item mobile-only nav-divider">
                    <div className="mobile-user-greeting">
                      Hello, {user.displayName}
                    </div>
                  </li>
                  <li className="nav-item mobile-only">
                    <Link to={ROUTES.PROFILE} className="nav-link" onClick={closeMobileMenu}>
                      Profile
                    </Link>
                  </li>
                  {user.roles && user.roles.includes('admin') && (
                    <li className="nav-item mobile-only">
                      <Link to={ROUTES.ADMIN} className="nav-link admin-link" onClick={closeMobileMenu}>
                        Admin Panel
                      </Link>
                    </li>
                  )}
                  <li className="nav-item mobile-only">
                    <button onClick={handleLogout} className="nav-link logout-btn-mobile">
                      Sign Out
                    </button>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <div className="auth-section">
            {isAuthenticated && user && (
              <div className="user-menu">
                <div className="user-info">
                  <span className="user-name">Hello, {user.displayName}</span>
                  {user.avatarUrl ? (
                    <img 
                      src={user.avatarUrl} 
                      alt={user.displayName}
                      className="user-avatar"
                    />
                  ) : (
                    <div className="user-avatar-placeholder">
                      {user.displayName.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="user-dropdown">
                  <Link to={ROUTES.PROFILE} className="dropdown-item" onClick={closeMobileMenu}>
                    Profile
                  </Link>
                  {user.roles && user.roles.includes('admin') && (
                    <Link to={ROUTES.ADMIN} className="dropdown-item admin-link" onClick={closeMobileMenu}>
                      Admin Panel
                    </Link>
                  )}
                  <button onClick={handleLogout} className="dropdown-item logout-btn">
                    Sign Out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;